import H3 from "../Headings/H3Element";
interface GeneratingLoaderProps {
  label: string
}

const GeneratingLoader: React.FC<GeneratingLoaderProps> = ({ label = "Saving..." }) => {
  return (
    <>
      <div className="loader-wrapper" style={{ width: "100vw", background: "rgba(0,0,0,0.5)", left: 0, zIndex: 10 }}>
        <div>
          <div className="loader loader-1 my-5">
            <div className="loader-outter" />
            <div className="loader-inner" />
            <div className="loader-inner-1" />
          </div>
          <H3 className="text-center text-light">{label}</H3>
        </div>
      </div>
    </>
  );
};

export default GeneratingLoader;
